import { Howler, Howl } from "howler";

/* Adjust "global" sound settings */
// attempt to silently unlock audio playback by playing an empty buffer on the first touchend event. This seems to work on iOS
Howler.autoUnlock = true;
const sounds = {};

export function registerSound({ src, loop, volume }) {
	return new Howl({
		src,
		loop,
		preload: true,
		volume,
	});
}

export const set = (id, { src, loop = false, volume = 1 }) => {
	sounds[id] = registerSound({ id, src, loop, volume });
};

export const get = (id) => {
	return sounds[id];
};

export const play = (id, { delay = 0 } = {}) => {
	setTimeout(() => {
		!get(id).playing() && get(id).play();
	}, delay);
	return get(id);
};

export const stop = (id, { delay = 0 } = {}) => {
	setTimeout(() => {
		get(id).stop();
	}, delay);
	return get(id);
};

export const fade = (id, { from = 0, to = 1, duration = 1000 } = {}) => {
	return get(id).fade(from, to, duration);
};
